module.exports = __webpack_public_path__ + "img/image-upload.d1aa69bf.png";